import PageHero from '@/components/shared/PageHero';
import VolunteerForm from '@/components/forms/VolunteerForm';
import { Card, CardContent } from '@/components/ui/card';
import { motion } from 'framer-motion';
import { CheckCircle2, Users, HeartHandshake, GraduationCap, ShieldCheck } from 'lucide-react';
import useSEO from '@/hooks/useSEO';

const BENEFITS = [
    {
        icon: Users,
        title: 'Onboarding & mentorship',
        body: 'Meet a program lead, understand SOPs and get paired with a mentor.',
    },
    {
        icon: HeartHandshake,
        title: 'Meaningful impact',
        body: 'Work in a program aligned with your interests — education, health, environment or employment.',
    },
    {
        icon: GraduationCap,
        title: 'Certificate of hours',
        body: 'Formal certification of volunteer hours — useful for students and professionals.',
    },
    {
        icon: ShieldCheck,
        title: 'Safe & inclusive',
        body: 'A respectful environment with clear code of conduct and safeguards.',
    },
];

export default function VolunteerPage() {
    useSEO({
        title: 'Volunteer with Us',
        description:
            'Join VVVSI Trust as a volunteer — become part of a 3,400+ strong grassroots family. Contribute to education, health, environment, disaster relief and employment programs across Tamil Nadu & Puducherry.',
    });
    return (
        <div data-testid="volunteer-page">
            <PageHero
                eyebrow="Volunteer"
                title="Become part of a 3,400+ strong grassroots family."
                subtitle="Whether you can spare an hour a week or a full day a month, we'll match you to work that fits."
            />
            <section className="section-pad">
                <div className="container-page grid lg:grid-cols-12 gap-10 items-start">
                    <div className="lg:col-span-5">
                        <h2 className="font-display text-2xl sm:text-3xl font-semibold mb-4">
                            What you can expect
                        </h2>
                        <div className="space-y-4">
                            {BENEFITS.map((b, i) => {
                                const Icon = b.icon;
                                return (
                                    <motion.div
                                        key={b.title}
                                        initial={{ opacity: 0, y: 8 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4, delay: i * 0.05 }}
                                        viewport={{ once: true, margin: '-40px' }}
                                        className="flex items-start gap-3"
                                    >
                                        <div className="h-10 w-10 rounded-lg bg-[hsl(var(--primary))]/8 text-[hsl(var(--primary))] flex items-center justify-center shrink-0">
                                            <Icon className="h-5 w-5" />
                                        </div>
                                        <div>
                                            <div className="font-semibold">{b.title}</div>
                                            <div className="text-sm text-muted-foreground leading-relaxed">
                                                {b.body}
                                            </div>
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="lg:col-span-7">
                        <VolunteerForm />
                    </div>
                </div>
            </section>
        </div>
    );
}
